import { useAction, useAtom } from "@reatom/npm-react";
import { useEffect } from "react";
import { formatRubles } from "src/util";

import { ResponsivePromotionWidget } from "../ResponsivePromotionWidget";
import { RateCard } from "./components";
import { useRegistrationDiscount } from "./hooks/useRegistrationDiscount";
import { rates } from "./RatesWidget.constants";
import css from "./RatesWidget.module.scss";
import { getRatesPricesRequest } from "./store/fetchers/getRatesPrices";
import { getBaseDiscount } from "./utils/getBaseDiscount";

interface RatesWidgetProps {
  isLanding?: boolean;
}

const formatPrice = (price: number) => `${formatRubles(price)} / Месяц`;

export const RatesWidget = ({ isLanding }: RatesWidgetProps) => {
  const fetchPrices = useAction(getRatesPricesRequest);
  const [priceMap] = useAtom(getRatesPricesRequest.dataAtom);
  const [isPricesLoading] = useAtom(getRatesPricesRequest.isLoadingAtom);
  const { isActive, isExpired, timeLeft, discountPercent } =
    useRegistrationDiscount();

  useEffect(() => {
    fetchPrices();
  }, [fetchPrices]);

  return (
    <>
      <div className={css.ratesList}>
        {rates.map((rate) => {
          const fetchedPrice = priceMap?.[rate.type];

          const discount =
            rate.type === "base"
              ? getBaseDiscount({
                  isActive,
                  isExpired,
                  fetchedPrice,
                  discountPercent,
                  timeLeft,
                })
              : undefined;

          return (
            <RateCard
              key={rate.title}
              {...rate}
              price={
                fetchedPrice !== undefined
                  ? formatPrice(fetchedPrice)
                  : rate.price
              }
              priceLoading={!!rate.meta && isPricesLoading}
              isLanding={isLanding}
              discount={discount}
            />
          );
        })}
      </div>

      <ResponsivePromotionWidget />
    </>
  );
};
